import { useState } from "react";
import { footer } from "../../../config/appData";
import "./SocialProfilesSection.css";

const PLATFORM_ICONS = {
  Instagram: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="url(#insta-gradient)">
      <defs>
        <linearGradient id="insta-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f09433" />
          <stop offset="50%" stopColor="#e6683c" />
          <stop offset="100%" stopColor="#dc2743" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="url(#insta-gradient)" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="none" stroke="#fff" strokeWidth="2" />
      <circle cx="17.5" cy="6.5" r="1.5" fill="#fff" />
    </svg>
  ),
  Facebook: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#1877F2">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  ),
  Pinterest: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#E60023">
      <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
    </svg>
  ),
  YouTube: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#FF0000">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
};

const PLATFORM_BTN_COLOR = {
  Instagram: "#0095f6",
  Facebook: "#1877F2",
  Pinterest: "#E60023",
  YouTube: "#FF0000",
};

function SocialProfileCard({ card, index }) {
  const [imageError, setImageError] = useState(false);
  const rawImage = card.image && !imageError ? card.image : null;
  const imageUrl = rawImage
    ? rawImage.startsWith("http")
      ? rawImage
      : `${process.env.PUBLIC_URL || ""}${rawImage.startsWith("/") ? rawImage : `/${rawImage}`}`
    : null;
  const handleDisplay = card.handle.startsWith("@") ? card.handle : `@${card.handle}`;
  const btnColor = PLATFORM_BTN_COLOR[card.platform] || "#1a1a1a";

  return (
    <a
      href={card.url}
      target="_blank"
      rel="noopener noreferrer"
      className="social-profile-card"
    >
      <div className="social-profile-card-header">
        <span className="social-profile-card-icon" aria-hidden="true">
          {PLATFORM_ICONS[card.platform] || null}
        </span>
        <span className="social-profile-card-handle">
          {handleDisplay} on {card.platform}
        </span>
      </div>
      <div className="social-profile-card-image-wrap">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={`${card.platform} profile`}
            className="social-profile-card-image"
            onError={() => setImageError(true)}
            loading="lazy"
          />
        ) : (
          <div className="social-profile-card-placeholder" data-platform={card.platform} />
        )}
        {card.overlayLabel && (
          <span className="social-profile-card-overlay">{card.overlayLabel}</span>
        )}
      </div>
      <span
        className="social-profile-card-btn"
        style={{ backgroundColor: btnColor }}
      >
        {card.buttonText}
      </span>
    </a>
  );
}

export default function SocialProfilesSection() {
  const cards = footer.socialProfileCards || [];
  if (cards.length === 0) return null;

  return (
    <section className="social-profiles-section" aria-label="Follow us on social media">
      <div className="social-profiles-container">
        <div className="social-profiles-grid">
          {cards.map((card, index) => (
            <SocialProfileCard key={`${card.platform}-${index}`} card={card} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
